import React from "react";
import {change, formValueSelector, reducer as formReducer, reduxForm , resetSection } from "redux-form";
import {combineReducers, createStore} from "redux";
import {connect, Provider} from "react-redux";
import {RATDFinish, RATDForm} from "../components/BaseForm";
import "../index.css"
import FormHandlers from "../FormHandlers";
import {DropDownMenu, InputField} from "../components/FormElements";
import "./index.css";
import {SelectModel} from "../components/ModelListContainer";
import oneSvg from "../images/1.svg"
import twoSvg from "../images/2.svg"
import threeSvg from "../images/3.svg"
import tickSvg from "../images/Tick.svg";
import SVG from 'react-inlinesvg';
import {YourDetailsNoPostcodeMarketing} from "../components/YourDetails"
import {RATDValidator, transformVehicle, validatePostcode} from "../util/Validators";
import {RequestATestDriveDirectCall} from "../components/DTMDirectCalls";

const rootReducer = combineReducers({
    form: formReducer,
});


const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const SUBMISSION_URL = process.env.REACT_APP_RATD_URL;
const VERSION = process.env.REACT_APP_VERSION_ID;
const DEALERS_URL = process.env.REACT_APP_VPC_DEALERS_API_URL;

class TransitionWrapper extends React.Component {

    render() {
        const props = this.props;
        return (<div className={`select-model-true your-details-true testdrive-true`}>{props.children}</div>)

    }
}

const FormTransitionWrapper = (props) => {

    const FormTransitionComponent = connect((state) => {
        const selector = formValueSelector(props.formName);
        return {
            formState: selector(state, 'formState'),
            firstname: selector(state, 'firstname'),
            lastname: selector(state, 'lastname'),
            email: selector(state, 'email'),
            postcode: selector(state, 'postcode'),
            phone: selector(state, 'phone'),
            'marketingOptIn': selector(state, 'marketingOptIn'),
            testdrivetiming: selector(state, 'testdrivetiming'),
            dealerfound: selector(state, 'dealerfound'),

            completed: selector(state, 'completed'),

        }
    })(reduxForm({form: props.formName})(TransitionWrapper));

    return <FormTransitionComponent {...props} />
};


function App(props) {
    const {brand, config} = props;
    const formName = props.formName || "fca-ratd";

    const handlers = FormHandlers(SUBMISSION_URL, brand, config, {
        onSubmit: async function (values, dispatch, props) {
            if (values) {
                const {vehicle, marketingOptIn, testdrivetiming, postcode, year, email , digitalData} = values;
                RequestATestDriveDirectCall(brand,config, true).complete(vehicle, year || config[transformVehicle(vehicle)].year, postcode, testdrivetiming, marketingOptIn,email, digitalData, window);
            }
            return {};
        },
        onSubmitSuccess: async function (results, dispatch, props) {
            dispatch(change(formName, 'completed', true));
            dispatch(change(formName, 'response', results));
            setTimeout(() => {
                if (window.parentIFrame) {
                    window.parentIFrame.moveToAnchor("#top");
                }
            }, 500);

        }
    });

    RequestATestDriveDirectCall(brand, config , true).start();

    return (
        <Provider store={store}>
            <a name="top" data-version={VERSION}/>

            <div className={`${brand.value} container-fluid pl-0 pr-0`}>
                <FormTransitionWrapper formName={formName}>

                    <RATDForm id={'satd'} formName={formName} loader={props.loader}
                              handlePrePopulateModel={() => {
                              }}
                              componentWillMountCallback={async (p) => {
                                  return {}
                              }}
                              optionalConfig={{
                                  asyncChangeFields : ['postcode'],
                                  asyncValidate :  validatePostcode,
                                  validate: (values) => {
                                      return RATDValidator(values);
                                  },
                                  initialValues: {
                                      completed: false,
                                      brand: brand,
                                      models: props.models,
                                      'firstname': "",
                                      'lastname': "",
                                      'postcode': '',
                                      'email': '',
                                      'phone': '',
                                      'marketingOptIn': true,
                                      'vehicle': '',
                                      'eVar39': '',
                                      'GACLIENTID': '',
                                      'testdrivetiming': '',
                                      'loaddealer': false,
                                      'dealerfound': false,
                                      brandConfig: config,
                                      formState: {
                                          'selectModel': false,
                                      }
                                  }
                              }}
                              onSubmit={handlers.onSubmit}
                              onSubmitFail={handlers.onSubmitFail}
                              onSubmitSuccess={handlers.onSubmitSuccess}
                              isFormValid={(props) => {
                                  const {formValues} = props;
                                  if (formValues !== undefined) {
                                      const {vehicle, models,postcode, testdrivetiming , dealerfound} = formValues;
                                      const m = models.map(i => i.toLowerCase().trim());
                                      const v = vehicle.toLowerCase().trim();
                                      return /^[0-9]{4}$/.test(postcode) && dealerfound && [vehicle, testdrivetiming].every((i) => i !== undefined && i.trim().length > 0) && m.includes(v)
                                  } else {
                                      return false;
                                  }
                              }}

                    >

                        <SelectModel formName={formName} icon={oneSvg} handleClick={() => {

                        }}/>
                        <hr className={'separator step-1'}/>
                        <RequestATestDrive formName={formName} loader={props.loader} icon={twoSvg} handleClick={() => {

                        }}/>
                        <hr className={'separator step-2'}/>
                        <YourDetailsNoPostcodeMarketing formName={formName} icon={threeSvg}/>


                    </RATDForm>

                </FormTransitionWrapper>
                <RATDFinish formName={formName} data={"response"}/>


            </div>
        </Provider>
    )
}

function RequestATestDrive(props) {
    const {formName, icon} = props;

    async function LookupDealerByPostCodeAndDivision({postcode, division}) {
        const response = await fetch(`${DEALERS_URL}?postcode=${postcode}&division=${division}&department=sales`);
        if (response.ok) {
            const json = await response.json();
            return Object.assign({}, json.dealers[0], {success: true});
        } else {
            return Object.assign({}, {}, {success: true});
            //return {success: false};
        }
    }

    function Component(p) {
        const {testdrivetiming, postcode, dispatch, brand, dealer, loaddealer, handleClick} = p;
        const isCompleted = [postcode, testdrivetiming].every((i) => i !== undefined && i.trim().length > 0) && dealer !== undefined;

        return (
            <div id={'testdrive'}
                 className={"testdrive col-12 col-lg-6 col-md-12 offset-lg-3 " + (isCompleted ? ` selected ` : ` `)}>
                <a name="testdrive"/>
                <div className={"d-flex justify-content-center section-heading"}>
                    {!isCompleted && <SVG src={icon}/>}
                    {isCompleted && <SVG src={tickSvg}/>}
                    <h4 className={"pl-1 pt-1"}>&nbsp;FIND A LOCAL DEALER</h4>
                </div>

                <DropDownMenu labelText={"YOUR TEST DRIVE AVAILABILITY"} name={'testdrivetiming'} required={false} items={["This week", "Within 2 weeks", "Within 1 month"]}/>

                <InputField labelText={"Your postcode"} name={"postcode"} type={"text"} required={false}
                            placeholder={"E.g. 2000"}/>

                {loaddealer && <div className={'card border-0'}>
                    <div className="card-body">
                        <div className="card-text text-center">
                            <SVG src={props.loader}/>
                        </div>
                    </div>
                </div>}

                {dealer && dealer.name && <div className={"card"}>
                    <div className="card-body">
                        <div className="card-text">
                            <h4>{dealer.name}</h4>
                            <p>{dealer.address.line1} {dealer.address.city} {dealer.address.state} {dealer.address.postal_code} </p>
                        </div>
                    </div>
                </div>}

            </div>);
    }

    const RequestATestDriveComponent = connect((state) => {
        const selector = formValueSelector(formName);

        return {
            testdrivetiming: selector(state, 'testdrivetiming'),
            postcode: selector(state, 'postcode'),
            brand: selector(state, 'brand'),
            loaddealer: selector(state, 'loaddealer'),
            'dealer': selector(state, 'dealer')
        }
    })(Component);

    return <RequestATestDriveComponent {...props} />

}


export default App;
